import { gql, NetworkStatus, useQuery } from '@apollo/client'

import { currentArtistVar } from '@/clients/utoniq-core'
import {
  ArtistBottomTabFragmentDoc,
  CurrentUserFragmentDoc,
  GalleryCategoryQuery,
  GalleryCategoryQueryVariables,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ artistId: string }>()
  const artistId = router.query.artistId ?? config.artistId

  const { data, networkStatus, loading } = useQuery<
    GalleryCategoryQuery,
    GalleryCategoryQueryVariables
  >(GALLERY_CATEGORY, {
    variables: {
      artistId,
    },
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      if (data?.artist) {
        currentArtistVar(data.artist)
      }
    },
  })

  return {
    state: {
      categories: data?.artist?.postCategory?.categories,
      user: data?.user,
      loading,
      refetching: networkStatus === NetworkStatus.fetchMore,
      artistName: data?.artist?.displayName || '',
      liveStreamId: data?.artist?.currentLive?.id,
    },
    actions: {},
  }
})

const GALLERY_CATEGORY = gql`
  query GalleryCategory($artistId: ID!) {
    artist(id: $artistId) {
      ...ArtistBottomTab
      id
      displayName
      postCategory {
        id
        categories {
          id
          name
          description
          createdAt
          updatedAt
        }
      }
      currentLive {
        id
      }
    }
    user {
      ...CurrentUser
    }
  }
  ${ArtistBottomTabFragmentDoc}
  ${CurrentUserFragmentDoc}
`
